'use strict';

// (C) Copyright 2014-2016 Hewlett Packard Enterprise Development LP

module.exports = require('./ja-JP');


//////////////////
// WEBPACK FOOTER
// ./~/grommet/messages/icons/ja.js
// module id = 199
// module chunks = 0